const initialState = {
  isShowLongestPath: false,
  isEnableDefaultMeetingWithinGeofence: false,
  isDisableDefaultMeetingWithoutInfo: false,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "LONGEST_PATH":
      return {
        ...state,
        isShowLongestPath: action.payload,
      };
    case "ENABLE_DEFAULT_MEETING_WITHIN_GEOFENCE":
      return {
        ...state,
        isEnableDefaultMeetingWithinGeofence: action.payload,
      };
    case "START_OD_AUTOMATICALLY_AFTER_MIDNIGHT":
      return {
        ...state,
        isStartOdAutomaticallyAfterMidnight: action.payload,
      };
    case "ENABLE_COMPANY_WISE_USER_GOOGLE_ROUTE_MODE":
      return {
        ...state,
        isEnableCompanyWiseUserGoogleRouteMode: action.payload,
      };
    case "DISABLE_DEFAULT_MEETING_WITHOUT_INFO":
      return {
        ...state,
        isDisableDefaultMeetingWithoutInfo: action.payload,
      };
    default:
      return state;
  }
};

export { initialState, reducer };
